import { useState } from 'react';

export default function Hero() {
  const [showJoinModal, setShowJoinModal] = useState(false);

  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center px-4 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/9a0a3f8537e59ad590f2d5b17239b428.jpg"
            alt="Minecraft Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-[#0a0e1a]"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto text-center pt-20">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <img
              src="https://static.readdy.ai/image/de1d28f06a6d46e7b7740ea0cb3b85f9/6c034f3ae4b5cab658b4163946ad3240.png"
              alt="Windo5DJ Logo"
              className="h-32 md:h-40 w-auto drop-shadow-2xl"
            />
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg">
            Windo5DJ
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Eşsiz Minecraft deneyimi için hazır mısın? Arkadaşlarınla birlikte maceraya atıl!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <button 
              onClick={() => setShowJoinModal(true)}
              className="bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white px-8 py-4 rounded-lg text-lg font-bold hover:from-[#2563eb] hover:to-[#1d4ed8] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-fill mr-2"></i>
              Sunucuya Katıl
            </button>
            <a
              href="https://discord.gg/7MzuPKd9SD"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#5865F2] text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-[#4752C4] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-discord-fill mr-2"></i>
              Discord'a Katıl
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-[#1a1f35]/80 to-[#0f1420]/80 backdrop-blur-sm rounded-xl p-6 border border-[#3b82f6]/20">
              <div className="text-3xl md:text-4xl font-bold text-[#3b82f6] mb-2">
                <span className="bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full" style={{ fontFamily: 'Minecraft, monospace' }}>
                  YAKINDA
                </span>
              </div>
              <div className="text-gray-400 text-sm">Aktif Oyuncu</div>
            </div>
            <div className="bg-gradient-to-br from-[#1a1f35]/80 to-[#0f1420]/80 backdrop-blur-sm rounded-xl p-6 border border-[#3b82f6]/20">
              <div className="text-3xl md:text-4xl font-bold text-[#3b82f6] mb-2">29ms</div>
              <div className="text-gray-400 text-sm">Ortalama Ping</div>
            </div>
            <div className="bg-gradient-to-br from-[#1a1f35]/80 to-[#0f1420]/80 backdrop-blur-sm rounded-xl p-6 border border-[#3b82f6]/20">
              <div className="text-3xl md:text-4xl font-bold text-[#3b82f6] mb-2">-</div>
              <div className="text-gray-400 text-sm">Özel Mod</div>
            </div>
            <div className="bg-gradient-to-br from-[#1a1f35]/80 to-[#0f1420]/80 backdrop-blur-sm rounded-xl p-6 border border-[#3b82f6]/20">
              <div className="text-3xl md:text-4xl font-bold text-[#3b82f6] mb-2">
                <i className="ri-calendar-line"></i>
              </div>
              <div className="text-gray-400 text-sm">Hafta Sonu 13:00-21:00</div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="animate-bounce">
            <i className="ri-arrow-down-line text-white text-3xl"></i>
          </div>
        </div>
      </section>

      {/* Join Server Modal */}
      {showJoinModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl max-w-2xl w-full border border-[#3b82f6]/30 shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-[#3b82f6]/20 sticky top-0 bg-gradient-to-br from-[#1a1f35] to-[#0f1420] z-10">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold text-white">
                  <i className="ri-gamepad-line mr-2"></i>
                  Sunucuya Nasıl Katılırım?
                </h3>
                <button
                  onClick={() => setShowJoinModal(false)}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Step 1 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">1</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Minecraft'ı Aç</h4>
                    <p className="text-gray-400 text-sm mb-3">
                      Minecraft Java Edition'ı başlatın ve ana menüye gelin.
                    </p>
                    <div className="bg-[#1a1f35] rounded-lg p-3 border border-[#3b82f6]/10">
                      <i className="ri-information-line text-[#3b82f6] mr-2"></i>
                      <span className="text-gray-300 text-sm">Minecraft Java Edition 1.8 veya üzeri gereklidir</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">2</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Çok Oyunculu'ya Tıkla</h4>
                    <p className="text-gray-400 text-sm">
                      Ana menüden "Multiplayer" veya "Çok Oyunculu" butonuna tıklayın.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">3</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Sunucu Ekle</h4>
                    <p className="text-gray-400 text-sm mb-4">
                      "Add Server" veya "Sunucu Ekle" butonuna tıklayın ve aşağıdaki bilgileri girin:
                    </p>
                    
                    {/* Skyblock Server */}
                    <div className="mb-4">
                      <div className="flex items-center gap-2 mb-2">
                        <i className="ri-treasure-map-line text-[#3b82f6]"></i>
                        <span className="text-white font-semibold">Skyblock Sunucusu</span>
                      </div>
                      <div className="bg-[#1a1f35] rounded-lg p-4 border border-[#3b82f6]/10">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-gray-400 text-sm">Sunucu Adresi:</span>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText('emerald.magmanode.com:30515');
                            }}
                            className="text-[#3b82f6] hover:text-[#2563eb] transition-colors cursor-pointer text-sm"
                          >
                            <i className="ri-file-copy-line mr-1"></i>
                            Kopyala
                          </button>
                        </div>
                        <code className="text-[#3b82f6] font-mono text-sm block">emerald.magmanode.com:30515</code>
                      </div>
                    </div>

                    {/* BoxPvP Server */}
                    <div>
                      <div className="flex items-center gap-2 mb-2">
                        <i className="ri-sword-line text-[#3b82f6]"></i>
                        <span className="text-white font-semibold">BoxPvP Sunucusu</span>
                      </div>
                      <div className="bg-[#1a1f35] rounded-lg p-4 border border-[#3b82f6]/10">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-gray-400 text-sm">Sunucu Adresi:</span>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText('Windo5DJBX.aternos.me');
                            }}
                            className="text-[#3b82f6] hover:text-[#2563eb] transition-colors cursor-pointer text-sm"
                          >
                            <i className="ri-file-copy-line mr-1"></i>
                            Kopyala
                          </button>
                        </div>
                        <code className="text-[#3b82f6] font-mono text-sm block">Windo5DJBX.aternos.me</code>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">4</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Sunucuya Bağlan</h4>
                    <p className="text-gray-400 text-sm mb-3">
                      Sunucu adresini girdikten sonra "Done" veya "Bitti" butonuna tıklayın. 
                      Ardından sunucuya çift tıklayarak veya "Join Server" butonuna basarak bağlanın.
                    </p>
                    <div className="bg-gradient-to-r from-[#3b82f6]/10 to-[#2563eb]/10 rounded-lg p-4 border border-[#3b82f6]/20">
                      <div className="flex items-start gap-3">
                        <i className="ri-lightbulb-line text-[#3b82f6] text-xl flex-shrink-0 mt-0.5"></i>
                        <div>
                          <p className="text-white font-semibold text-sm mb-1">İpucu</p>
                          <p className="text-gray-300 text-sm">
                            Sunucuya ilk kez bağlanıyorsanız, kayıt olmanız gerekebilir. 
                            Oyun içi komutları takip edin!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Help Section */}
              <div className="bg-gradient-to-r from-[#3b82f6]/10 to-[#2563eb]/10 rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-2xl text-[#3b82f6]"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-2">Yardıma mı İhtiyacın Var?</h4>
                    <p className="text-gray-400 text-sm mb-4">
                      Sunucuya bağlanırken sorun yaşıyorsan Discord sunucumuzdan destek alabilirsin!
                    </p>
                    <a
                      href="https://discord.gg/7MzuPKd9SD"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 bg-[#5865F2] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#4752C4] transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-discord-fill"></i>
                      Discord'a Git
                    </a>
                  </div>
                </div>
              </div>

              {/* Close Button */}
              <button
                onClick={() => setShowJoinModal(false)}
                className="w-full bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white py-4 rounded-lg font-semibold hover:from-[#2563eb] hover:to-[#1d4ed8] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Anladım, Hadi Oynayalım!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
